import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const gridLayoutDefaultVariants = {
  "gap": "md",
  "justify": "center",
  "align": "start",
  "items": "center",
  "overflow": "auto",
  "flex": "fill",
  "padding": "lg"
}
const gridLayoutCompoundVariants = []

const gridLayoutSlotNames = [
  [
    "root",
    "grid-layout__root"
  ]
]
const gridLayoutSlotFns = /* @__PURE__ */ gridLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, gridLayoutDefaultVariants, getSlotCompoundVariant(gridLayoutCompoundVariants, slotName))])

const gridLayoutFn = memo((props = {}) => {
  return Object.fromEntries(gridLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const gridLayoutVariantKeys = [
  "gap",
  "justify",
  "align",
  "items",
  "overflow",
  "flex",
  "padding"
]
const getVariantProps = (variants) => ({ ...gridLayoutDefaultVariants, ...compact(variants) })

export const gridLayout = /* @__PURE__ */ Object.assign(gridLayoutFn, {
  __recipe__: false,
  __name__: 'gridLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: gridLayoutVariantKeys,
  variantMap: {
  "gap": [
    "none",
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "justify": [
    "start",
    "center",
    "end",
    "between",
    "around",
    "evenly"
  ],
  "align": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "items": [
    "start",
    "center",
    "end",
    "stretch"
  ],
  "overflow": [
    "auto",
    "hidden",
    "visible"
  ],
  "flex": [
    "fill",
    "auto",
    "none"
  ],
  "padding": [
    "none",
    "sm",
    "md",
    "lg"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, gridLayoutVariantKeys)
  },
  getVariantProps
})